import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const Container = styled(Accordion.Item) `
  &:not(:last-child) {
    border-bottom: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  }

  padding: ${themeGet('spacing.xl')};
`;
